import { useMatch } from '@tanstack/react-location';
import { VoicemailMessage } from '@frontend/phone';
import { PortalPageLayout } from '../../../../../../../layout';

export default function VoicemailMessagePage() {
  const { params } = useMatch();

  return (
    <PortalPageLayout>
      <VoicemailMessage mailboxId={params.mailboxId} messageId={params.messageId} />
    </PortalPageLayout>
  );
}
